import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useGlobalState } from '@/hooks/useGlobalState'
import type { GetResourcesResponse } from '@/services/api/api.types'

export function useStepResources(stepId: string | undefined | null) {
  const { api } = useGlobalState()

  const stepResourcesQuery = useQuery({
    queryKey: ['step', 'resources', 'all', stepId],
    queryFn: async () => {
      return api.request<GetResourcesResponse>('/cm/get_resources', 'get', {
        step_id: stepId!,
      })
    },
    enabled: !!stepId,
  })

  const stepResources = stepResourcesQuery.data

  const uploadedFileResource = stepResources?.find(
    r => r.isSourceFile && r.type !== 'text' && r.type !== 'url' && r.type !== 'youtube',
  )

  const sourceFileResource = useMemo(() => {
    const resource = stepResources?.find(r => r.isSourceFile)
    if (!resource) return undefined
    return resource
  }, [stepResources])

  return { stepResources, uploadedFileResource, sourceFileResource }
}
